import React from 'react';
import {toast} from 'react-toastify';

import {
  UPDATE_MARKETING_CONSENT_PENDING,
  UPDATE_MARKETING_CONSENT_FULFILLED,
  UPDATE_MARKETING_CONSENT_REJECTED,
  GET_MARKETING_CONSENTS_FULFILLED,
  GET_MARKETING_CONSENTS_PENDING,
  GET_MARKETING_CONSENTS_REJECTED,
  GET_MARKETING_CONSENT_FULFILLED,
  GET_MARKETING_CONSENT_PENDING,
  GET_MARKETING_CONSENT_REJECTED
} from '../reducers/marketingConsentsReducer';
import irelandApi from '../irelandApi';
import ToastMessage from '../components/common/toast-message';


export const getMarketingConsents = () => (dispatch) => {
  dispatch({type: GET_MARKETING_CONSENTS_PENDING, payload: []});
  return irelandApi.get('/api/admin/marketing_consents')
    .then((response) => {
      dispatch({type: GET_MARKETING_CONSENTS_FULFILLED, payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: GET_MARKETING_CONSENTS_REJECTED, payLoad: error.data});
    });
};

export const getMarketingConsent = params => (dispatch) => {
  dispatch({type: GET_MARKETING_CONSENT_PENDING, payload: []});
  return irelandApi.get('/api/marketing_consent', params)
    .then((response) => {
      dispatch({type: GET_MARKETING_CONSENT_FULFILLED, payLoad: response.data.data.attributes});
    })
    .catch((error) => {
      dispatch({type: GET_MARKETING_CONSENT_REJECTED, payLoad: error.data});
    });
};

export const updateMarketingConsent = payload => (dispatch) => {
  dispatch({type: UPDATE_MARKETING_CONSENT_PENDING, payload});
  return irelandApi.patch(`/api/admin/marketing_consents/${payload.identifier}`, {content: payload.content})
    .then(() => {
      toast.info(<ToastMessage iconStyle="info" message="Marketing Consent saved successfully"/>, {autoClose: 2000});
      dispatch({type: UPDATE_MARKETING_CONSENT_FULFILLED});
    })
    .catch((error) => {
      toast.warn(<ToastMessage iconStyle="warning" message="Unable to set marketing consent text"/>, {autoClose: 2000});
      dispatch({type: UPDATE_MARKETING_CONSENT_REJECTED, payLoad: error.data});
    });
};




// WEBPACK FOOTER //
// ./src/actions/marketing_consent.js